define('drops/button/button',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/onlongpress'
], function ($, Drop, Style, util, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            text: 'New Button',
            useDynamicWidth: true,
            useDynamicHeight: true,
            longPressDelay: 1000
        }
    };

    function Button(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.defaultStyleSettings = {
            text: { verticalAlign: 'middle' }
        };

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$button = $('<div/>')
            .addClass('boxToBorderSize drop-text-content')
            .attr('name', this.data.name)
            .text(this.data.text)
            .attr('title', this.data.title)
            .attr('tabindex', this.data.tabIndex)
            .css({
                display: 'table-cell',
                width: '100%'
            });

        // WHY setting 'display: table' on $element would break centered anchoring, so we have to add a wrapper
        this.$element
            .append($('<div />')
                .css({
                    cursor: 'pointer',
                    display: 'table',
                    whiteSpace: 'pre-wrap',
                    height: '100%',
                    width: '100%'
                })
                .append(this.$button));

        Style.renderStyles(this, null, this.$button);

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            OnLongPress.applyLongPressOnElement(this.$button, this);
        } else if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            var self = this;

            this.applyEventTrigger('clicked', 'click');

            this.$element
                .on('keypress', function (e) {
                    if (e.keyCode === 13) {
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName);
                    }
	            });
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');
    };

    Drop.extend(Button);

    Button.typeName = 'Button';

    Button.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$button);
    };

    Button.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    return Button;
});
